module.exports = __webpack_public_path__ + "img/person-circle.85ccf731.svg";